import Image from "next/image";
import Link from "next/link";

const socials = [
    { name: "facebook", image: "/images/socials/facebook.svg", url: "https://www.facebook.com/reassurezmoi" },
    { name: "instagram", image: "/images/socials/instagram.svg", url: "https://www.instagram.com/reassurezmoi.fr/" },
    { name: "twitter", image: "/images/socials/twiter.svg", url: "https://twitter.com/reassurezmoi" },
    { name: "linkedin", image: "/images/socials/linkedin.svg", url: "https://www.linkedin.com/company/reassurez-moi" },
    { name: "youtube", image: "/images/socials/youtube.svg", url: "https://www.youtube.com/@ReassurezmoiFr1" },
];

export default function FooterSocials() {
    return (
        <div className="flex flex-wrap gap-2 text-pale">
            {socials.map(({ name, image, url }) => (
                <Link
                    className="w-[40px] h-[40px] lg:w-[28px] lg:h-[28px] bg-white transition hover:bg-white/70 rounded-full flex items-center justify-center"
                    key={name}
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`Reassurez-moi ${name}`}
                >
                    <Image className={"lg:hidden"} src={image} alt={`Reassurez-moi ${name}`} width={20} height={20} />

                    <Image className={"hidden lg:block"} src={image} alt={`Reassurez-moi ${name}`} width={16} height={16} />
                </Link>
            ))}
        </div>
    );
}
